<template>
  <owal-modal-panel
    :bottom-buttons="bottomButtons"
    :title="title"
    class="image-selector-panel__panel-container"
    @button-click="handleButtonClick"
  >
    <owal-poster-frame-spinner
      v-if="loading"
      text="Loading Images..."
      style="height: 60%"
    />
    <div
      v-for="(sourcePhoto, index) in sourceImages"
      v-else
      :key="index"
      :class="`image-selector-panel__image-container${selectedImages.indexOf(sourcePhoto.detection_id) >= 0 ? '_selected' : ''}`"
    >
      <img
        v-lazy="sourcePhoto.imageURL"
        class="image-selector-panel__candidate-photo"
        onerror="handleError"
        @click="selectSourcePhoto(sourcePhoto.detection_id)"
      >
      <div
        v-if="multipicker"
        class="check__container"
      >
        <div
          v-if="selectedImages.indexOf(sourcePhoto.detection_id) >= 0"
          class="owal-tagging-panel__circle_checked"
        >
          ✓
        </div>
        <div
          v-else
          class="owal-tagging-panel__circle_unchecked"
        >
          -
        </div>
      </div>
    </div>
  </owal-modal-panel>
</template>

<script>
import OwalModalPanel from '@/libraries/owal-ui/panels/OwalModalPanel'
import OwalPosterFrameSpinner from '@/libraries/owal-ui/spinners/OwalPosterFrameSpinner'

export default {
  name: 'PhotoSelectorPanel',
  components: {
    OwalModalPanel,
    OwalPosterFrameSpinner,
  },
  props: {
    sourceImages: {
      type: Array,
      required: true,
    },
    imageId: {
      type: String,
    },
    title: {
      type: String,
    },
    multipicker: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedImages: [],
    }
  },
  computed: {
    bottomButtons () {
      let buttons = [{
        title: 'Cancel',
        identifier: 'close',
      }]

      if (this.multipicker) {
        buttons.splice(0, 0, {
          title: 'Save',
          identifier: 'selection-complete',
        })
      }

      return buttons
    },
  },
  methods: {
    handleButtonClick (identifier) {
      if (identifier === 'close') {
        this.$emit('close')
      } else {
        const payload = this.multipicker ? this.selectedImages : this.selection[0]
        this.$emit('selection-complete', payload)
      }
    },
    selected (imageId) {
      return this.selectedImages.indexOf(imageId) > 0
    },
    handleError (error) {
      window.bugsnagClient.notify(error)
    },
    selectSourcePhoto (imageId) {
      if (!this.multipicker) {
        this.$emit('selection-complete', imageId)
      } else {
        const imageIndex = this.selectedImages.indexOf(imageId)
        if (imageIndex >= 0) {
          this.selectedImages.splice(imageIndex, 1)
        } else {
          this.selectedImages.push(imageId)
        }
      }
    },
  },
}
</script>

<style scoped>
.image-selector-panel__panel-container >>> .owal.panel.container{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.image-selector-panel__image-container,
.image-selector-panel__image-container_selected {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background: #fff;
  flex-grow: 0;
  flex-shrink: 0;
  z-index: 9;
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  width: 33%;
}

.image-selector-panel__candidate-photo {
  background: #000;
  border: 3px solid #fff;
  border-radius: 0.5rem;
  object-fit: contain;
  max-height:250px;
  transform: scale(1);
  box-shadow: 0;
  transition: all 200ms ease-in;
  text-align: center;
  justify-content: center;
  align-content: center;
  align-items: center;
  width:100%;
  height:100%;
}

.image-selector-panel__image-container:hover {
  transform: scale(1.05);
  z-index: 1000;
}

.image-selector-panel__image-container_selected {
  box-shadow: 0 0 4px 0 rgba(92, 128, 168, 0.5), 0 25px 35px 0 rgba(0,0,0,0.10);
  z-index: 10;
  border-radius: 5px;
}

.image-selector-panel__image-container_selected .image-selector-panel__candidate-photo {
  border: 2px solid rgba(171,213,124, 1);
}

.image-selector-panel__image-confirm {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff88;
  backdrop-filter: blur(8px);
  color: #475669;
  font-size: 3rem;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  border: 5px solid #DE187D;
  border-radius: 5px;
  overflow: hidden;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

  @media only screen and (max-height: 950px),
  only screen and (max-width: 950px) {
    .event-verification__candidate-confirm {
      font-size: 2rem;
    }
  }

  @media only screen and (max-width: 800px) {
    .image-selector-panel__image-container,
    .image-selector-panel__image-container_selected,
    .image-selector-panel__image-container:hover {
      padding: 2px;
      border-radius: 2px;
    }

    .image-selector-panel__image-container .event-verification__key,
    .image-selector-panel__image-container_selected .event-verification__key {
      opacity: 0;
      border-radius: 5px;
      transform: scale(0.1);
    }

    .event-verification__candidate-confirm {
      font-size: 1rem;
    }

    .event-verification__candidate-confirm {
      border-width: 0.15rem;
    }

  }

  @media only screen and (max-width: 414px) and (max-height: 736px) {
    .image-selector-panel__image-container,
    .image-selector-panel__image-container_selected,
    .image-selector-panel__image-container:hover {
      padding: 2px;
      border-radius: 2px;
    }
  }

.image-selector-panel__image-container,
 .image-selector-panel__image-container_selected{
  border-radius: 0.5rem;
  margin: 0;
  padding: 0;
}

.owal-tagging-panel__circle_checked,
.owal-tagging-panel__circle_unchecked {
  height: 1.8rem;
  width: 1.8rem;
  border-radius: 50%;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: flex-end;
  position: relative;
  margin-top: -0.5rem;
  margin-right: 0rem;
  margin-left: auto;
  transition: background 300ms ease, color 300ms ease;
  z-index: 30;
}

.owal-tagging-panel__circle_checked {
  border: 2px solid #EFF2F7;
  background: rgba(171,213,124, 1);
  color: #fff;
}

.owal-tagging-panel__circle_unchecked {
  background: #475669;
  color: #C0CCDA;
  border: 2px solid #EFF2F7;
}

@media screen and (max-width: 580px){
  .image-selector-panel__image-container,
 .image-selector-panel__image-container_selected {
  flex-basis: 8rem;
  margin: 0 1rem;
 }

  .owal-tagging-panel__circle_checked,
  .owal-tagging-panel__circle_unchecked {
    margin-right: -1rem;
  }
}
</style>
